import { AdminApiAdminV2FacilitiesGetRequest } from '@sbv-clients/data-access-api';

export const buildApiFiltersFactory = () => {
  type FiltersType = Omit<
    AdminApiAdminV2FacilitiesGetRequest,
    'facilityId' | 'page' | 'pageSize'
  >;

  type EditableFiltersType = {
    -readonly [K in keyof FiltersType]: FiltersType[K];
  };

  const output: Partial<EditableFiltersType> = {};
  const factory = {
    appendIfDefined(key: keyof EditableFiltersType, value: any) {
      if (value !== undefined) {
        output[key] = value;
      }
      return factory;
    },
    build() {
      return output;
    },
  };
  return factory;
};
